import {
  poTemplateSchema,
  type PoTemplate,
} from "@redotech/redo-fulfillment-operations-common/purchase-order-document";
import * as z from "zod";

export const updatePoTemplate = {
  name: "updatePoTemplate" as const,
  input: poTemplateSchema as z.ZodType<PoTemplate>,
  output: poTemplateSchema,
};
